module.exports = __webpack_public_path__ + "img/team-classic-1-370x397.37a8bf45.jpg";